import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Projects = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="projects-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <SEO path="/projects" title="AFHOS Projects" description="Active research programmes and community health initiatives across Africa — including HeartCare@Home, Pan-African Hypertension Registry, and SALT-Africa Study." />
      <div className="page-header">
        <p className="overline">{t('projects.overline')}</p>
        <h1 data-testid="projects-title">{t('projects.title')}</h1>
        <p>{t('projects.subtitle')}</p>
      </div>

      <div className="content-section">
        <div className="card" style={{ borderLeft: '4px solid var(--brand)', padding: '2rem' }}>
          <p className="overline">{t('projects.flagshipOverline')}</p>
          <h2 style={{ marginBottom: '0.75rem' }}>{t('projects.flagshipTitle')}</h2>
          <p>{t('projects.flagshipP1')}</p>
          <p>{t('projects.flagshipP2')}</p>
        </div>
      </div>

      <div className="content-section">
        <h2>{t('projects.activeTitle')}</h2>
        <div className="grid-3">
          <div className="card">
            <h4>{t('projects.proj1Title')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('projects.proj1Desc')}</p>
          </div>
          <div className="card">
            <h4>{t('projects.proj2Title')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('projects.proj2Desc')}</p>
          </div>
          <div className="card">
            <h4>{t('projects.proj3Title')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('projects.proj3Desc')}</p>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>{t('projects.capacityTitle')}</h2>
        <p>{t('projects.capacityDesc')}</p>
      </div>

      <div className="content-section">
        <h2>{t('projects.involvedTitle')}</h2>
        <p>
          {t('projects.involvedDesc')} <a href="mailto:info@afhos.africa">info@afhos.africa</a>
        </p>
      </div>
    </div>
  );
};

export default Projects;
